<!-- src/App.vue -->

<template>
  <div id="app" :class="{ 'dark-theme': isDarkTheme }">
    <AppHeader @theme-toggled="toggleTheme" :isDarkTheme="isDarkTheme" />
    <div class="content">
      <router-view />
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';

export default {
  components: {
    AppHeader,
    AppFooter,
  },
  setup() {
    // Инициализация темы из localStorage
    const isDarkTheme = ref(localStorage.getItem('theme') === 'dark');

    // Функция для переключения темы
    const toggleTheme = () => {
      isDarkTheme.value = !isDarkTheme.value;
      localStorage.setItem('theme', isDarkTheme.value ? 'dark' : 'light');
    };

    // Следим за изменениями темы и добавляем/удаляем класс на body
    watch(isDarkTheme, (newVal) => {
      document.documentElement.classList.toggle('dark-theme', newVal);
    });

    // Устанавливаем начальное состояние темы при монтировании
    onMounted(() => {
      document.documentElement.classList.toggle(
        'dark-theme',
        isDarkTheme.value
      );
    });

    return { isDarkTheme, toggleTheme };
  },
};
</script>

<style>
/* Стили остались без изменений */
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Helvetica', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  transition: background-color 0.3s ease, color 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: 70px;
}

.content {
  flex: 1;
}
</style>
